import { Outlet, Link, useNavigate } from 'react-router-dom';
import { Button } from '@/platform/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/platform/ui/dropdown-menu';
import { Avatar, AvatarFallback } from '@/platform/ui/avatar';
import { LogOut, Settings, Building2 } from 'lucide-react';
import { useAuth } from '@/platform/auth/auth-context';
import { useUserSession } from '@/platform/auth/user-session-context';
import { signOut } from '@/platform/auth/auth-client';

export function ParticipantLayout() {
  const { user } = useAuth();
  const { isParticipantOnly } = useUserSession();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth/login');
  };

  const initials = user?.email ? user.email.substring(0, 2).toUpperCase() : 'U';

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="h-14 border-b bg-card flex items-center justify-between px-6">
        {isParticipantOnly ? (
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded bg-primary flex items-center justify-center">
              <span className="text-primary-foreground text-xs font-bold">CBA</span>
            </div>
            <span className="font-semibold text-sm hidden sm:block">Conscious Brand Assessment</span>
          </div>
        ) : (
          <Link to="/participant/dashboard" className="flex items-center gap-2">
            <div className="h-7 w-7 rounded bg-primary flex items-center justify-center">
              <span className="text-primary-foreground text-xs font-bold">CBA</span>
            </div>
            <span className="font-semibold text-sm hidden sm:block">Conscious Brand Assessment</span>
          </Link>
        )}

        <div className="flex items-center gap-2">
          {!isParticipantOnly && (
            <Button variant="ghost" size="sm" asChild>
              <Link to="/participant/organisations" className="gap-2">
                <Building2 className="h-4 w-4" />
                <span className="hidden sm:inline">My Organisations</span>
              </Link>
            </Button>
          )}

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="h-9 w-9 rounded-full p-0">
                <Avatar className="h-9 w-9">
                  <AvatarFallback className="text-xs">{initials}</AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-52">
              <DropdownMenuLabel className="font-normal">
                <p className="text-sm font-medium">{user?.email}</p>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              {!isParticipantOnly && (
                <>
                  <DropdownMenuItem onClick={() => navigate('/settings')}>
                    <Settings className="mr-2 h-4 w-4" />
                    Settings
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                </>
              )}
              <DropdownMenuItem onClick={handleSignOut}>
                <LogOut className="mr-2 h-4 w-4" />
                Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </header>

      <main className="flex-1 container max-w-3xl mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}

